export default __webpack_public_path__ + "static/media/phone-red.9bed27cb.svg";